import { Component, OnInit, Input, Inject } from '@angular/core';
import { InspectionService } from '../inspection.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'quorum-inspection-cause-correction-dialog',
  templateUrl: './inspection-cause-correction-dialog.component.html',
  styleUrls: ['./inspection-cause-correction-dialog.component.scss'],
})
export class InspectionCauseCorrectionDialog implements OnInit {
  @Input() task: any;

  constructor(
    public inspectionService: InspectionService,
    public dialogRef: MatDialogRef<InspectionCauseCorrectionDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      task: any;
    }
  ) {}
  ngOnInit() {}

  setSaveCommentsFlag(task: any) {
    task.saveComments = true;
  }

  cancel() {
    this.dialogRef.close();
  }

  save(task: any) {
    this.dialogRef.close(task);
  }
}
